import { Component } from 'react';
import { withRouter } from 'react-router';
import { withSteps } from 'Common/StepComponent';

import { AeriesConfigurationStep } from './components/AeriesConfigurationStep/AeriesConfigurationStep';
import { AeriesMappingStep } from './components/AeriesMappingStep/AeriesMappingStep';
import { AeriesPreviewStep } from './components/AeriesPreviewStep/AeriesPreviewStep';
import { AeriesImportStep } from './components/AeriesImportStep/AeriesImportStep';

export class AeriesIntegrationContainer extends Component {
  static title = 'Aeries Integration';

  render() {
    return null;
  }
}

export const AeriesIntegration = withRouter(
  withSteps([
    AeriesConfigurationStep,
    AeriesMappingStep,
    AeriesPreviewStep,
    AeriesImportStep,
  ])(AeriesIntegrationContainer)
);



// WEBPACK FOOTER //
// ./src/pages/aeriesintergration/AeriesIntegration.js